<template>
    <div class="tip_text" v-html="tipText" />
</template>

<script>
import bus from "@/utils/bus";

export default {
  props: {
    tipText: {
      type: String,
      default: "", // 提示文本
    },
    allowFileType: {
      type: Array,
      default: () => [], // 允许上传文件类型，空数组表示无限制
    },
    fileMax: {
      type: Number,
      default: 0, // 以字节为单位；0表示无限制
    },
  },

  data() {
    return {
      fileSize: 0, // 文件大小
      limitSizePass: true,
      limitTypePass: true,

      currentProp: {}, // 用于保存当前组件属性；因为当一个文件创建多个该组件时，只会保留最后创建的组件数据
    };
  },

  created() {
    bus.$off("beforeUpload");
    bus.$on("beforeUpload", this.beforeUpload);
  },

  mounted() {},
  methods: {
    // 拦截上传之前事件（做校验）
    beforeUpload(file, who) {
      this.currentProp = who.$props;
      this.limitFileType(file.name); // 先校验文件类型

      if (this.limitTypePass) {
        this.limitSize(file.size); // 再校验文件大小
      }

      bus.uploadPass = this.limitSizePass && this.limitTypePass;
    },

    // 限制文件大小
    limitSize(fileSize) {
      // console.log('limitSize', fileSize, this.currentProp)
      let fileSizeLabel = "";

      if(fileSize < 1024 && fileSize / 1024 < 0){ // 小于1k
        fileSizeLabel = this.currentProp.fileMax + 'b'
      } else if(fileSize > 1024 && fileSize < 1024 * 1000){ // 大于1k，小于1m
        fileSizeLabel = Math.ceil(this.currentProp.fileMax / 1024) + 'k'
      }else if(fileSize > 1024 * 1000){ // 大于1m
        fileSizeLabel = Number(this.currentProp.fileMax / 1024 / 1000).toFixed(0) + 'M'
      }

      // 0：无限制
      if (this.currentProp.fileMax === 0) {
        this.limitSizePass = true;
        return;
      }
      if (fileSize > this.currentProp.fileMax) {
        this.limitSizePass = false;
        this.$message({
          type: "warning",
          message: `该文件不能超过${fileSizeLabel}`,
        });
      } else {
        this.limitSizePass = true;
      }
    },
    // 限制文件类型
    limitFileType(name) {
      if (!this.currentProp.allowFileType.length) {
        this.limitTypePass = true;
        return;
      }

      const fileSuffix = name
        .slice(name.lastIndexOf("."))
        .replace(".", "")
        .toLocaleLowerCase(); // .DOC => doc

      this.limitTypePass = this.currentProp.allowFileType.includes(fileSuffix);
      if (!this.limitTypePass) {
        this.$message({
          type: "warning",
          message: `不支持该文件格式！`,
        });
      }
      // console.log('limitFileType', name, this.currentProp, this.limitTypePass)
    },
  },
};
</script>

<style lang="scss" scoped>
.tip_text{
  line-height: 16px;
}
</style>
